'use strict'
import store from '../store'

function getToken() {
  return store.getters['mobile/mobileToken'] || ''
}

const service = process.env.VUE_APP_service_licenze || ''

const getFilteredCustomers = async function (base, filtri, opzioni, istanzaDb) {
  try {
    const data = {
      base,
      filtri,
      opzioni,
      istanzaDb
    }
    const response = await fetch(`${service}/mobile/clienti/filter`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + getToken()
      },
      body: JSON.stringify(data)
    })
    return await response.json()
  } catch (err) {
    console.log('getFilteredCustomers', err)
  }
}

export default {
  getFilteredCustomers
}
